import {
  GETFEEREPORTFILE_SUCCESS,
  GETFEEREPORTFILE_FAILED,
  RESET_GETFEEREPORTFILE,
  LOADING_GETFEEREPORTFILE,
  NETWORK_ERROR_GETFEEREPORTFILE,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_GETFEEREPORTFILE:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case GETFEEREPORTFILE_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case GETFEEREPORTFILE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_GETFEEREPORTFILE:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_GETFEEREPORTFILE:
      return (state = initialState);
    default:
      return state;
  }
};
